<template>
  <div>
    <d-table
      tableName="packages"
      :data_object="data_object"
      :getFreshData="true"
      addButtonCaption="Add Portal"
      :linkClick="linkClick"
      :link="link"
      :editRow="true"
      :alwaysUpdate="true"
      :hasSearch="true"
      ref="dTable"
      :key="tableKey"
    />
  </div>
</template>

<script>
import DTable from "../components/Table";
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "Portals",
  components: { DTable },
  props: {},
  data() {
    return {
      data_object: {
        object_name: "portals",

        // mobileBreakpoint: 0,
        all_records: true,

        hasSearch: true,
      },
      link: {
        field: "shipment_id",
        name: "shipment",
      },
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
  },
};
</script>

<style lang="css" scoped></style>
